'use client';
import type { Assign } from '@ark-ui/react';
import { Accordion } from '@ark-ui/react';
import { type AccordionVariantProps, accordion } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(accordion);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Accordion.RootProviderProps>,
    AccordionVariantProps
  >
>(Accordion.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Accordion.RootProps>,
    AccordionVariantProps
  >
>(Accordion.Root, 'root');

export const ItemContent = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Accordion.ItemContentProps>
>(Accordion.ItemContent, 'itemContent');

export const ItemIndicator = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Accordion.ItemIndicatorProps>
>(Accordion.ItemIndicator, 'itemIndicator');

export const Item = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Accordion.ItemProps>
>(Accordion.Item, 'item');

export const ItemTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Accordion.ItemTriggerProps>
>(Accordion.ItemTrigger, 'itemTrigger');

export {
  AccordionContext as Context,
  AccordionItemContext as ItemContext,
} from '@ark-ui/react';

export type {
  AccordionFocusChangeDetails as FocusChangeDetails,
  AccordionValueChangeDetails as ValueChangeDetails,
} from '@ark-ui/react';
